/**
 * 계정정보찾기 페이지 라우트
 * FSD: pages/account-recovery/route
 */

import { RouteObject } from "react-router-dom";
import { AccountRecoveryPage } from "./ui/AccountRecoveryPage";

export const accountRecoveryRoute: RouteObject = {
  path: "/account-recovery",
  element: <AccountRecoveryPage />,
};
